/* eslint-disable no-shadow */
export enum LoanPreOfferStatus {
  approved = "approved",
  expired = "expired",
  rejected = "rejected",
}

export enum LoanOfferRejectionReason {
  InvalidTier = "InvalidTier",
  NoViableOffers = "NoViableOffers",
  InvalidParams = "InvalidParams",
}

export enum PaymentFrequency {
  weekly = "weekly",
  monthly = "monthly",
}

export enum ProfileTier {
  B1 = "B1",
  B1_CREDIT_LINE = "B1-CreditLine",
  B2 = "B2",
  B3 = "B3",
  NB = "NB",
  HARD_REJECT = "HARD_REJECT",
  FRAUD = "FRAUD",
}
